module.exports = ""


//////////////////
// WEBPACK FOOTER
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/dashboard/chat/menu/menu.component.html
// module id = ../../../../../src/app/dashboard/chat/menu/menu.component.html
// module chunks = dashboard.module